import {ADD_ERROR, REMOVE_ERROR} from '../constants/error';

export function addError(error) {
  return ({type: ADD_ERROR, payload: {error}});
}

export function removeError(errorId) {
  return ({type: REMOVE_ERROR, payload: {id: errorId}});
}
